import { getCookie } from "./apiBridge";
const isProduction = process.env.NODE_ENV === "production";
const matchAPI = isProduction ? '/api/match' : process.env.REACT_APP_MATCH_API_URL;

export async function getWebActivityList() {
    return requestWebAPI(`${matchAPI}/web/activity/list`, 'GET', null)
}

export async function getWebActivityDetail(activityId: string) {
    return requestWebAPI(`${matchAPI}/web/activity/${activityId}/info`, 'GET', null)
}

export async function getWebActivityParticipants(activityId: string, categoryId: number) {
  return requestWebAPI(`${matchAPI}/web/activity/${activityId}/participants?category_id=${categoryId}`, 'GET', null)
}

export async function getWebActivityMatches(activityId: string, categoryId: number) {
  return requestWebAPI(`${matchAPI}/web/activity/${activityId}/matches?category_id=${categoryId}`, 'GET', null)
}

export function getWebRTDSUrl(activityId: string, key: string) {
  return `${matchAPI}/rtds/ws?activity_id=${activityId}&key=${key}`
}

export function getWebActivityLogoUrl(activityId: string) {
  return `${matchAPI}/activity/${activityId}/logo`
}
 
async function requestWebAPI(apiUrl: string, method: 'GET' | 'POST', body: any) {
    let options :RequestInit = {
      method: method,
    }

    let token = getCookie("token");
    if (token) {
      options.headers = {
        Authorization: "Bearer " + token,
      }
    }
  
    if (body) options.body = JSON.stringify(body);
  
    try {
      const response = await fetch(apiUrl, options);
  
      return response;
    } catch (error: any) {
      console.error("Fetch error:", typeof error, error);
      return new Response(JSON.stringify({ error: error.message }), {
        status: 500,
        headers: { "Content-Type": "application/json" },
      });
    }
  }

